import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useHistory, useParams } from 'react-router-dom';
import { Button, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Label, Modal, Row, Table } from 'reactstrap';
import { InputField } from 'src/components';
import BetterBreadcrumb from 'src/components/Common/BetterBreadCrumb';
import { setFromErrors } from 'src/helpers';
import { useAppSelector } from 'src/rtk/app/hook';
import { useCreateDOPSFormEntryBySupervisorMutation, useCreateFeedBackForAssesmentMutation, useLazyGetSessionWiseMiniCexListQuery } from 'src/rtk/features/miniCexCBD/miniCexAndCBDApi';
import * as Yup from 'yup';
import loader from '../../assets/images/loader.gif';
import PatientInformationUpdateForDOPS from './PatientInformationUpdateForDOPS';

const SupervisorDOPSformEntry = () => {
    const { regNo: registrationNo, id: supervisorId, logbookSessionId: sessionId } = useParams<{
        regNo: string;
        id: string;
        logbookSessionId: string;
    }>();

    const history = useHistory();
    const [getSessionWiseMiniCexList, { data }] = useLazyGetSessionWiseMiniCexListQuery();

    useEffect(() => {
        const url = {
            registrationNo: registrationNo,
            supervisorId: supervisorId
        }
        getSessionWiseMiniCexList(url);
    }, []);
    const authUser = useAppSelector((state) => state.auth.user);

    const userInfo: any = data?.data?.trainee_info || ({} as RegInfo);
    const dopsInfo: any = data?.data?.dops_trainee?.find((item: any) => item?.assessments === null) || {};


    const dopsData = [
        { id: 1, name: "Demonstrated the understanding", slug: 'demonstrated_the_understanding' },
        { id: 2, name: "Counselling", slug: 'counselling' },
        { id: 3, name: "Informed consent", slug: 'informed_consent' },
        { id: 4, name: "Appropriate preparation", slug: 'appropriate_preparation' },
        { id: 5, name: "Appropriated analgesia/sedation", slug: 'appropriated_analgesia_sedation' },
        { id: 6, name: "Aseptic technique", slug: 'aseptic_technique' },
        { id: 7, name: "Technical ability", slug: 'technical_ability' },
        { id: 8, name: "Professionalism", slug: 'professionalism1' },
        { id: 9, name: "Post procedural management", slug: 'post_procedural_management' },
        { id: 10, name: "Awareness and Management of complications", slug: 'awareness_and_management_of_complications' },
        { id: 11, name: "Communication skills", slug: 'communication_skills' },
        { id: 12, name: "Overall ability to perform procedure", slug: 'overall_ability' },
        { id: 13, name: "Professionalism", slug: 'professionalism2' },
    ];

    const [dopsAssesmentData, setDopsAssesmentData] = useState<any>({});
    const [assesorSatisfication, setAssesorSatisfication] = useState<number>();
    const [totalScore, setTotalScore] = useState<number>(0);
    const [modalShow, setModalShow] = useState(false);

    const [assesmentOption, setAssesmentOption] = useState(Array(dopsData.length).fill(''));

    const allOptions: SelectOption[] = [
        { label: '0', value: 0 },
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 },
        { label: '6', value: 6 },
        { label: '7', value: 7 },
        { label: '8', value: 8 },
        { label: '9', value: 9 },
    ];

    const [createDOPSFormEntryBySupervisor, { isSuccess, isError, error, isLoading: isCreateLoading }] = useCreateDOPSFormEntryBySupervisorMutation();
    const [createFeedBackForAssesment, { isSuccess: isFeedBackSuccess, isError: isFeedBackError, error: feedBackError, isLoading: isFeedBackLoading }] = useCreateFeedBackForAssesmentMutation();

    const err1: CustomError = feedBackError as CustomError;

    const err: CustomError = error as CustomError;

    const initialValues = {
        registration_id: '',
        supervisor_id: '',
        logbook_entry_session_id: '',
        trainee_form_id: '',
        date_of_assessment: new Date(Date.now()).toISOString().slice(0, 10),
        input_validation_supervisor: false,
        overall_performance: '',
        areas_of_strength: '',
        suggestions_for_development: '',
        total_score: '',
        avg_score: '',
        evaluation_time: '',
        feedback_time: '',
    }

    const {
        handleSubmit,
        getFieldProps,
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
        resetForm,
        setFieldValue,
        setErrors,
    } = useFormik({
        initialValues,

        validationSchema: Yup.object({
            date_of_assessment: Yup.date().max(new Date(Date.now()), 'Date of assessment can\'t be a future date').required(),
            overall_performance: Yup.string().required('This is Required'),
            areas_of_strength: Yup.string().required('This is Required'),
            suggestions_for_development: Yup.string().required('This is Required'),
        }),

        onSubmit: (values: any) => {
            values.competencies = [];

            values.registration_id = userInfo?.registration_no;
            values.supervisor_id = userInfo?.current_session_and_supervisor_info?.supervisor?.id;
            values.logbook_entry_session_id = userInfo?.current_session_and_supervisor_info?.id;
            values.trainee_form_id = dopsInfo?.id;
            values.total_score = totalScore;
            values.avg_score = +(totalScore / dopsData.length).toFixed(2);

            Object.keys(dopsAssesmentData).forEach((key) => {
                values.competencies.push(dopsAssesmentData[key]);
            })

            if (values.competencies.length === dopsData.length) {
                createDOPSFormEntryBySupervisor(values);
            }
            else {
                toast.error('Please Select all assesment');
            }
            console.log(dopsAssesmentData);
        },
    });


    useEffect(() => {
        if (isSuccess) {
            const arr = Array(dopsData.length).fill('');
            setAssesmentOption(arr);
            setDopsAssesmentData({});
            resetForm();
            setModalShow(true);
            toast.success('Information Stored Successfully!');
        }
        if (isError) {
            toast.error(err?.message || 'Something Went Wrong!');
            setFromErrors(err.data, setErrors);
        }
    }, [isSuccess, isError]);


    const handleCompetences = (e: any, competence: string, id: string) => {
        const item = { ...dopsAssesmentData };

        if (e.target.value) {
            item[id] = {
                competence: competence,
                perform: e.target.value,
                descriptor: item[id]?.descriptor ?? '',
            }
        }
        setDopsAssesmentData(item);
    }


    const handleCompetencesRemarks = (e: any, id: string) => {
        const item = { ...dopsAssesmentData };
        if (e.target.value) {
            item[id] = {
                competence: item[id]?.competence ?? '',
                perform: item[id]?.perform ?? '',
                descriptor: e.target.value,
            }
        }
        setDopsAssesmentData(item);
    }

    useEffect(() => {
        let sum: number = 0;
        if (assesmentOption) {
            assesmentOption?.map((item) => sum = sum + (+item))
        }
        setTotalScore(sum);
    }, [assesmentOption]);

    const performanceNumber = [1, 2, 3, 4, 5, 6, 7, 8, 9];

    const performanceNumber2 = [
        { label: '1', value: 1, indicator: 'Unsatisfactory' },
        { label: '2', value: 2, indicator: 'Unsatisfactory' },
        { label: '3', value: 3, indicator: 'Unsatisfactory' },
        { label: '4', value: 4, indicator: 'Satisfactory' },
        { label: '5', value: 5, indicator: 'Satisfactory' },
        { label: '6', value: 6, indicator: 'Satisfactory' },
        { label: '7', value: 7, indicator: 'Superior' },
        { label: '8', value: 8, indicator: 'Superior' },
        { label: '9', value: 9, indicator: 'Superior' },
        { label: 'Not Observed', value: 0, indicator: 'Not Observed' },
    ];

    const feedBackData = {
        logbook_session_id: sessionId,
        user_id: authUser?.id,
        satisfactory_label: assesorSatisfication,
        type: 'dops-supervisor'
    };

    useEffect(() => {
        if (isFeedBackSuccess) {
            resetForm();
            toast.success('Feedback Given Successfully!');
            setModalShow(false);
            history.push('/dops-list');
        }
        if (isFeedBackError) {
            toast.error(err?.message || 'Something Went Wrong!');
            setFromErrors(err.data, setErrors);
        }
    }, [isFeedBackSuccess, isFeedBackError]);

    return (
        <div className='page-content'>
            {isCreateLoading ? (
                <div className="overlay">
                    <img src={loader} alt="Loading" height={100} width={300} />
                </div>
            ) : null}
            <Container fluid>
                <BetterBreadcrumb
                    breadcrumbItem={[{ link: '/dops-list', name: 'DOPS' }]}
                    title={'Direct Observation of Procedural Skills'}
                />
                <Card className='mt-2'>
                    <CardHeader>
                        <h4 className='text-center'><u>Direct Observation of Procedural Skills (DOPS)</u></h4>
                        <Row>
                            <Col>
                                <div>
                                    <span>
                                        <strong>Name of the Institution: </strong>
                                    </span>
                                    <span>
                                        {userInfo?.current_session_and_supervisor_info?.supervisor?.institute_name}
                                    </span>
                                </div>
                            </Col>
                            <Col>
                                <div className='row justify-content-end'>
                                    <div className='col-sm-3'>
                                        <strong>Date of Examination : </strong>
                                    </div>
                                    <div className='col-sm-4'>
                                        <InputField
                                            type="date"
                                            placeholder=""
                                            invalid={{ errors, touched }}
                                            name='date_of_assessment'
                                            value={values.date_of_assessment}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <div className="row">
                            <div className="col-md-6 col-sm-12 mb-2">
                                <h5 className="block-heading">1. Trainee Information</h5>
                                <table className="table table-bordered table-striped table-sm">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <strong>Name Of the Trainee: </strong>
                                                {userInfo?.personal_info?.full_name ?? 'N/A'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <strong>BMDC Reg No.: </strong>
                                                {userInfo?.bmdc_registration_no ?? 'N/A'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <strong>Speciality: </strong>
                                                {userInfo?.subject?.subject_name ?? 'N/A'}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <strong>Program: </strong>
                                                {'FCPS Part-2'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <strong>Year of Training: </strong>
                                                {userInfo?.current_session_and_supervisor_info?.slot_info?.training_type === 'Core' &&
                                                    <div>
                                                        <span>
                                                            <strong><u>FCPS Core: </u></strong>
                                                        </span>
                                                        <span>
                                                            {userInfo?.current_session_and_supervisor_info?.slot_info?.name ?? 'N/A'}
                                                        </span>
                                                    </div>
                                                }
                                                {userInfo?.current_session_and_supervisor_info?.slot_info?.training_type === 'Advance' &&
                                                    <div>
                                                        <span>
                                                            <strong><u>FCPS Speciality: </u></strong>
                                                        </span>
                                                        <span>
                                                            {userInfo?.current_session_and_supervisor_info?.slot_info?.name ?? 'N/A'}
                                                        </span>
                                                    </div>
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-md-6 col-sm-12 mb-2">
                                <h5 className="block-heading">2. Assessor's Information</h5>
                                <table className="table table-bordered table-striped table-sm">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <strong>Name of the assessor: </strong>
                                                {userInfo?.current_session_and_supervisor_info?.supervisor?.name ?? 'N/A'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <strong>Assessor’s specialty: </strong>
                                                {userInfo?.current_session_and_supervisor_info?.supervisor?.department_name ?? 'N/A'}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <strong>Assessor’s position: </strong>
                                                {userInfo?.current_session_and_supervisor_info?.supervisor?.designation ?? 'N/A'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <strong>Assessor’s phone number: </strong>
                                                {userInfo?.current_session_and_supervisor_info?.supervisor?.mobile ?? 'N/A'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <strong>Assessor’s email: </strong>
                                                {userInfo?.current_session_and_supervisor_info?.supervisor?.email ?? 'N/A'}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <PatientInformationUpdateForDOPS
                            registrationNo={registrationNo}
                            sessionId={sessionId}
                            supervisorId={supervisorId}
                            dopsInfo={dopsInfo}
                        />

                        {/* Supervisor Part Starts From Here */}

                        <Form
                            className="custom-form"
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleSubmit();
                            }}
                            onReset={(e) => {
                                // e.preventDefault();
                                setDopsAssesmentData({});
                                const arr = Array(dopsData.length).fill('');
                                setAssesmentOption(arr);
                                resetForm();
                            }}
                        >
                            <Row className='mt-3'>
                                <Col>
                                    <h5 className='block-heading'>6. Input Validation
                                        <i
                                            className="fas fa-info-circle mx-1"
                                            title="(Supervisor checks the electronic record against this case record)"
                                        ></i>
                                    </h5>
                                    <div className='form-check form-check-inline col-md-3'>
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="validate_supervisor"
                                            id="validate-supervisor"
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setFieldValue('input_validation_supervisor', true);
                                                }
                                                else {
                                                    setFieldValue('input_validation_supervisor', false);
                                                }
                                            }}
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="validate-supervisor"
                                        >
                                            Input Validated by Assessor/Supervisor
                                        </label>
                                    </div>
                                </Col>
                            </Row>
                            {values.input_validation_supervisor &&
                                <div>
                                    <Row className='mt-3'>
                                        <Col>
                                            <h5 className='block-heading'>7. Assesment
                                                <i
                                                    className="fas fa-info-circle mx-1"
                                                    title="Areas to consider for discussion and feedback"
                                                ></i>
                                            </h5>
                                            <div className='performance-assesment-indicator-wrapper'>
                                                {dopsData.map((item: any, index: number) => (
                                                    <div className='performance-assesment-indicator' key={item.id}>
                                                        <div>
                                                            {item.name}
                                                        </div>
                                                        <div className='performance-assesment-wrapper'>
                                                            {performanceNumber2?.map((perfomance: any) => (
                                                                <div key={perfomance?.value}>
                                                                    <input
                                                                        type="radio"
                                                                        name={item?.slug}
                                                                        value={perfomance?.value}
                                                                        id={index.toString() + '-' + perfomance?.value}
                                                                        onChange={(e: any) => {
                                                                            handleCompetences(e, item.name, item.id);
                                                                            const assesment = [...assesmentOption];
                                                                            assesment[index] = e.target.value;
                                                                            setAssesmentOption(assesment);
                                                                            // console.log(assesment)
                                                                        }}
                                                                    />
                                                                    <label className={perfomance?.indicator} htmlFor={index.toString() + '-' + perfomance?.value}><span>{perfomance?.indicator}</span>{perfomance?.label}</label>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <div>
                                                            <InputField
                                                                type="text"
                                                                placeholder="Remarks"
                                                                name='remarks'
                                                                onChange={(e: any) => {
                                                                    handleCompetencesRemarks(e, item.id);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                ))}
                                                <div className='fw-bold mt-2'>
                                                    <div><p>Total Score : {totalScore}</p> </div>
                                                </div>
                                                <div className='fw-bold'>
                                                    <div><p>Average Score : {(totalScore / dopsData.length).toFixed(2)}</p> </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row className='mt-3'>
                                        <h5 className='block-heading'>8. Overall Perfromance</h5>
                                        <Col sm={4}>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="overall_performance"
                                                    value="Competent"
                                                    onChange={(e) => {
                                                        setFieldValue("overall_performance", 'Competent');
                                                    }}
                                                    id="competent"
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="competent"
                                                >
                                                    Competent
                                                </label>
                                            </div>

                                            <div className="form-check form-check-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="overall_performance"
                                                    value="Not-Compentent"
                                                    onChange={(e) => {
                                                        setFieldValue("overall_performance", 'Not-Compentent');
                                                    }}
                                                    id="not_competent"
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="not_competent"
                                                >
                                                    Not yet competent/Needs repetition
                                                </label>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row className='mt-3'>
                                        <Col sm={6}>
                                            <Label>Comment of Areas of Strength of the trainee:
                                                <i
                                                    className="fas fa-info-circle mx-1"
                                                    title="(The assessor/supervisor writes a comment stating the areas of strength of the trainee)"
                                                ></i>
                                            </Label>
                                            <FormGroup>
                                                <InputField
                                                    type="textarea"
                                                    placeholder="Comment of Areas of Strength"
                                                    invalid={{ errors, touched }}
                                                    {...getFieldProps('areas_of_strength')}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col sm={6}>
                                            <Label>Suggestions for development/Improvement :
                                                <i
                                                    className="fas fa-info-circle mx-1"
                                                    title="(The assessor must complete this section and submit)"
                                                ></i>
                                            </Label>
                                            <FormGroup>
                                                <InputField
                                                    type="textarea"
                                                    placeholder="Suggestions for development/Improvement"
                                                    invalid={{ errors, touched }}
                                                    {...getFieldProps('suggestions_for_development')}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col sm={12}>
                                            <Table className='table table-bordered'>
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <div className='d-flex gap-2'>
                                                                <div>Total DOPS Evaluation Time:</div>
                                                                <div className='col-2'>
                                                                    <InputField
                                                                        type="number"
                                                                        min={'1'}
                                                                        invalid={{ errors, touched }}
                                                                        {...getFieldProps('evaluation_time')}
                                                                    />
                                                                </div>
                                                                <div>Minutes</div>
                                                            </div>
                                                        </th>
                                                        <th>
                                                            <div className='d-flex gap-2'>
                                                                <div>Time spent giving Feedback:</div>
                                                                <div className='col-2'>
                                                                    <InputField
                                                                        type="number"
                                                                        min={'1'}
                                                                        invalid={{ errors, touched }}
                                                                        {...getFieldProps('feedback_time')}
                                                                    />
                                                                </div>
                                                                <div>Minutes</div>
                                                            </div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                            </Table>
                                        </Col>
                                    </Row>

                                    <FormGroup className="mb-3 text-center mt-3">
                                        <Button
                                            type="reset"
                                            className="btn btn-secondary me-2"
                                        >
                                            Reset
                                        </Button>

                                        <button
                                            type="submit"
                                            className="btn btn-success"
                                        >
                                            Submit
                                        </button>
                                    </FormGroup>
                                </div>
                            }
                        </Form>
                    </CardBody>
                </Card>

                <Modal
                    onOpened={function () {
                        toast.dismiss();
                    }}
                    isOpen={modalShow}
                    toggle={() => {
                        document.body.classList.add('no_padding');
                    }}
                    backdrop={'static'}
                    modalTransition={{ timeout: 0 }}
                    backdropTransition={{ timeout: 0 }}
                    size='xl'
                >
                    <div className="modal-header">
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() => {
                                setModalShow(!modalShow);
                                history.push('/dops-list');
                            }}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <Row>
                            <Col sm={3}>
                                <Label>Satisfaction using Mini-CEX</Label>
                            </Col>
                            <Col sm={8}>
                                <span className='fw-bold'>LOW</span>
                                {performanceNumber?.map((item) => (
                                    <div key={item} className='form-check form-check-inline'>
                                        <button
                                            type='button'
                                            className={assesorSatisfication === item ? "btn btn-primary rounded-pill" : "btn btn-outline-primary rounded-pill"}
                                            onClick={() => {
                                                setAssesorSatisfication(item);
                                            }}
                                        >
                                            {item}
                                        </button>
                                    </div>
                                ))}
                                <span className='fw-bold'>HIGH</span>
                            </Col>
                        </Row>
                        <FormGroup className="text-end mt-3">
                            <button
                                type="button"
                                className="btn btn-danger me-1"
                                onClick={() => {
                                    setModalShow(!modalShow);
                                    history.push('/dops-list');
                                }}
                            >
                                Skip
                            </button>
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={() => {
                                    createFeedBackForAssesment(feedBackData);
                                }}
                                disabled={assesorSatisfication === undefined}
                            >
                                Submit
                            </button>
                        </FormGroup>
                    </div>
                </Modal>
            </Container>
        </div>
    );
};

export default SupervisorDOPSformEntry;
